import Vue from 'vue'
import Vuex from 'vuex'
import loginStoreModule from './store.login'
import userStoreModule from './store.user'
import urlStoreModule from './store.url'
import noticeStoreModule from './store.notice'
/* 관리자 */
import codeRequestStoreModule from './admin/store.code.request'
import gewCodeRequestStoreModule from  './admin/gew/store.gew.code.request'


Vue.use(Vuex);

export const store = new Vuex.Store({

  modules : {
    loginStore : loginStoreModule,
    userStore : userStoreModule,
    urlStore : urlStoreModule,
    noticeStore : noticeStoreModule,
    codeRequestStore : codeRequestStoreModule,
    gewCodeStore : gewCodeRequestStoreModule
  }
});

